module.exports = __webpack_public_path__ + "img/menu_4.51f84173.png";